import { AvatarComponent } from './avatar/avatar.component';
import { ModalComponent } from './modal/modal.component';
import { NoPhotoComponent } from './no-photo/no-photo.component';
import { YandexMapOldComponent } from './yandex-map/yandex-map.component';
import { NameComponent } from './name/name.component';
import { NetworkImageComponent } from './network-image/network-image.component';
import { SupportRequestBtnComponent } from './support-request-button/support-request-btn.component';
import { InputMaskComponent } from './phone-input/phone-input.component';

export const components = [
  NoPhotoComponent,
  NameComponent,
  NetworkImageComponent,
  InputMaskComponent,
  ModalComponent,
  YandexMapOldComponent,
  SupportRequestBtnComponent,
];

export * from './avatar/avatar.component';
export * from './no-photo/no-photo.component';
export * from './name/name.component';
export * from './network-image/network-image.component';
export * from './modal/modal.component';
export * from './yandex-map/yandex-map.component';
